import { render, staticRenderFns } from "./PreviewChooserItem.vue?vue&type=template&id=02fdc782&scoped=true&"
import script from "./PreviewChooserItem.vue?vue&type=script&lang=ts&"
export * from "./PreviewChooserItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fdc782",
  null
  
)

export default component.exports